const BaseModule = require('../../90_utils/base/BaseModule');

class ScrollNav extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$window = $(window);
		this.$navContent = this.$el.find('.scroll-nav-content-wrapper');

		this.$contentController = $('#page-content-controller');
		this.$mobileToggle = this.$el.find('.mobile-toggle');
		this.$bottomHero;
		this.$heroes;
		this.$heroes;
		this.$hitArea;
		this.$navItems;
		this.$primaryContentInnerBlocks;
		this.$progressHandles;
		this.$progressIndicators;
		this.$progressLines;
		this.$selectedNavItem;
		this.$topHero;

		this.navTemplate = _.template(this.$el.find('#scroll-nav-template').html());

		this.isBadPage = false;
		this.isPartitionedPage = true;
		this.isScrollSwap = false;

		this.isInteractionLocked = false;
		this.isMobile = false;
		this.isPageChanging = false;
		this.isPendingRebuild = false;
		this.isSectionShowing = false;
		this.isTrans = false;
		this.isTransOut = true;

		this.isHover = false;
		this.isLabelTransOut = false;
		this.isLabelVisible = true;
		this.isOverHero = false;
		this.isScrollVisible = false;
		this.isSiteLoaded = false;
		this.isTouch = false;

		this.labelDelay;
		this.labelDelayTime;
		this.pageChangeDelay;
		this.pageId;
		this.sectionId;

		this.footerHeroBounds;
		this.hitAreaBounds;
		this.mouseCoords;
		this.topHeroBounds;

		this.scrollTop = 0;
	}

	// built in methods

	_domReady(){
		this.$el.find('#scroll-nav-template').remove(); // cleanup
	}

	// listeners

	_addListeners(){

		this.$window.on('scroll', $.proxy(this._onScroll, this));
		this.$mobileToggle.on('click', $.proxy(this._onMobileToggleClick, this));
		this.$el.on('click', $.proxy(this._onClick, this));

		window.vent.on('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.on('linkChangeRoute', this._onLinkChangeRoute, this);
		window.vent.on('heroChangeRoute', this._onHeroChangeRoute, this);
		window.vent.on('heroChangeRouteComplete', this._onHeroChangeRouteComplete, this);
		window.vent.on('pageChangeStart', this._onPageChangeStart, this);
		window.vent.on('pageChangeComplete', this._onPageChangeComplete, this);
		window.vent.on('showScrollNav', this._onShowScrollNav, this);
		window.vent.on('hideScrollNav', this._onHideScrollNav, this);
		window.vent.on('expandScrollNav', this._onExpandScrollNav, this);
		window.vent.on('collapseScrollNav', this._onCollapseScrollNav, this);
		window.vent.on('mousemove', this._onMouseMove, this);
	}

	_removeListeners(){

		this.$window.off('scroll', $.proxy(this._onScroll, this));
		this.$mobileToggle.off('click', $.proxy(this._onMobileToggleClick, this));
		this.$el.off('click', $.proxy(this._onClick, this));

		window.vent.off('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.off('linkChangeRoute', this._onLinkChangeRoute, this);
		window.vent.off('heroChangeRoute', this._onHeroChangeRoute, this);
		window.vent.off('heroChangeRouteComplete', this._onHeroChangeRouteComplete, this);
		window.vent.off('pageChangeStart', this._onPageChangeStart, this);
		window.vent.off('pageChangeComplete', this._onPageChangeComplete, this);
		window.vent.off('showScrollNav', this._onShowScrollNav, this);
		window.vent.off('hideScrollNav', this._onHideScrollNav, this);
		window.vent.off('expandScrollNav', this._onExpandScrollNav, this);
		window.vent.off('collapseScrollNav', this._onCollapseScrollNav, this);
		window.vent.off('mousemove', this._onMouseMove, this);
	}

	// listener methods

	_onScroll(){

		let oldScrollTop = this.scrollTop;
		this.scrollTop = this.$window.scrollTop();
		let scrollDelta = this.scrollTop - oldScrollTop;

		if(!this.isBadPage && this.pageId){

			let winHeight = window.SETTINGS.coords.winHeight;
			let topHeroHeight = $('body').hasClass('page-action') ? winHeight * 2 : winHeight;
			let docHeight = window.SETTINGS.coords.getDocHeight();

			// TODO: check all heroes, not just top and bottom

			if((this.scrollTop < topHeroHeight - winHeight/2) ||
				(this.scrollTop <= docHeight - winHeight && this.scrollTop >= docHeight - winHeight/2*3)){

				if(!this.isOverHero){
					this.isOverHero = true;
					this.$el.addClass('is-over-hero');
				}
			}
			else {

				if(this.isOverHero){
					this.isOverHero = false;
					this.isInteractionLocked = false;
					this.$el.removeClass('is-over-hero');
				}
			}

			if(this.isInteractionLocked && scrollDelta !== 0){
				if(this.isScrollSwap && this.scrollTop >= winHeight * 1.25){
					this.isInteractionLocked = false;
					// console.log('interaction locked false');
				}
				else if(!this.isScrollSwap && this.scrollTop >= winHeight * 0.25){
					this.isInteractionLocked = false;
					// console.log('interaction locked false');
				}
			}

			// progress indicators

			if(this.isPartitionedPage){

				let routeObj = window.SETTINGS.router.getRouteObj();
				let pageSections = window.SETTINGS.pageSections[routeObj.pageId];
				let currentSection = routeObj.sectionId ? routeObj.sectionId : (pageSections.sections ? pageSections.sections[0].id : '');
				let pageSectionObj = pageSections && currentSection ? _.findWhere(pageSections.sections, {id: currentSection}) : null;

				if(pageSectionObj){

					let sectionIndex = pageSectionObj ? pageSections.sections.indexOf(pageSectionObj) : 0;

					if(!this.$primaryContentInnerBlocks || !this.$primaryContentInnerBlocks.length){
						this._updateCachedElements();
					}

					if(this.$progressIndicators && this.$primaryContentInnerBlocks && this.$primaryContentInnerBlocks.length){

						for(let i=0; i<this.$progressIndicators.length; i++){

							let scrollProgress = 0;
							let lineHeight = this.$progressLines.eq(0).outerHeight();

							if(i < sectionIndex){ scrollProgress = 1; }
							else if(i > sectionIndex){ scrollProgress = 0; }
							else {

								let $primaryBlock = this.$primaryContentInnerBlocks.eq(0);
								let blockScrollTop = $primaryBlock.offset().top;
								let blockHeight = $primaryBlock.outerHeight();

								scrollProgress = (this.scrollTop - blockScrollTop)/blockHeight;
							}

							this.$progressHandles.eq(i).css('height', Math.min(lineHeight, Math.max(0, scrollProgress) * lineHeight));
						}
					}
				}
			}
			else {

				this._setActiveNavItem();

				if(this.$progressIndicators && this.$primaryContentInnerBlocks && this.$primaryContentInnerBlocks.length){

					let scrollProgressStart = this.$contentController.offset().top;
					let maxProgress = this.$contentController.outerHeight() - scrollProgressStart;
					let numBlocks = Math.min(this.$progressIndicators.length, this.$primaryContentInnerBlocks.length);

					for(let i=0; i<numBlocks; i++){

						let $primaryBlock = this.$primaryContentInnerBlocks.eq(i);
						let blockHeight = $primaryBlock.outerHeight();
						let blockTop = $primaryBlock.offset().top;
						let blockBottom = blockTop + blockHeight;
						let lineHeight = this.$progressLines.eq(i).outerHeight();
						let scrollProgress = (this.scrollTop + winHeight - blockTop)/(blockHeight + winHeight);

						this.$progressHandles.eq(i).css('height', Math.min(lineHeight, Math.max(0, scrollProgress) * lineHeight));
					}
				}
			}
		}

		if(!this.isHover && !this.isInteractionLocked){
			this._hideLabels(0);
		}

		this._checkMousePos();
	}

	_onMobileToggleClick(e){

		if(e){ e.preventDefault(); }

		if(this.isHover){
			this._hitAreaOut();
			$('#main').off('click', $.proxy(this._onClickOut, this));
		}
		else {
			this._hitAreaOver();
			window.SETTINGS.animationFrame.one(() => {
				$('#main').on('click', $.proxy(this._onClickOut, this));
			});
		}
	}

	_onClick(e){

		if(!this.isHover && !this.isMobile){

			e.preventDefault();
			this._hitAreaOver();

			window.SETTINGS.animationFrame.one(() => {
				$('#main').on('click', $.proxy(this._onClickOut, this));
			});
		}
	}

	_onClickOut(e){

		let $target = $(e.target);

		if(!this.$el[0].contains($target[0])){

			e.preventDefault();
			this._hitAreaOut();

			$('#main').off('click', $.proxy(this._onClickOut, this));
		}
	}

	_onMouseMove(e, params){

		this.mouseCoords = {
			pageX: params.pageX,
			pageY: params.pageY,
			clientX: params.clientX,
			clientY: params.clientY
		}

		this._checkMousePos();
	}

	_onSiteLoadComplete(){
		this.isSiteLoaded = true;
		this._onPageChangeStart(null, {id: window.SETTINGS.router.getRouteObj.pageId});
		this._onScroll();
	}

	_onLinkChangeRoute(){
		this.isScrollSwap = false;
	}

	_onHeroChangeRoute(){
		this.isScrollSwap = true;
	}

	_onHeroChangeRouteComplete(){

	}

	_onPageChangeStart(e, params){
		this.isPageChanging = true;
		this._setPageStatus(params.id);
		this._sectionHide();
		this._resize();
	}

	_onPageChangeComplete(){

		let routeObj = window.SETTINGS.router.getRouteObj();

		this.isPageChanging = false;
		this._setPageStatus(routeObj.pageId);

		let isNewPage = (routeObj.pageId !== this.pageId);

		if(isNewPage){
			this.pageId = routeObj.pageId;
			this.sectionId = routeObj.sectionId;
		}

		if(!this.isBadPage){

			if(isNewPage){
				this._rebuild();
				this._sectionShow();
			}
			else {
				this._updateCachedElements();
				this._forceSectionShow();
			}
		}

		window.SETTINGS.animationFrame.one(() => {
			this._checkScrollVisibility();
			this._resize();
		});
	}

	_setPageStatus(pageId){

		this.isBadPage = false;
		this.isPartitionedPage = false;

		switch(pageId){

			case 'intro':
			case 'vision':
			this.isBadPage = true;
			break;

			case 'action':
			this.isPartitionedPage = true;
			break;
		}
	}

	_onShowScrollNav(){ }
	_onHideScrollNav(){ }
	_onExpandScrollNav(){ }
	_onCollapseScrollNav(){	}

	// template listeners (rebuilt every time nav is rebuilt)

	_addTemplateListeners(){

		let $buttons = this.$el.find('.nav-item a');
		$buttons.off('click');
		$buttons.on('click', this._onButtonClick.bind(this));
	}

	_onButtonClick(e){

		let $target = $(e.currentTarget);
		let $navItem = $target.closest('.nav-item');
		let $heroes = $('.hero');

		if(this.isPartitionedPage){

			let $closestHero = this._getClosestHero();
			let closestDistance = Math.abs(this.scrollTop + window.SETTINGS.coords.winHeight/2 - $closestHero.offset().top);

			if(closestDistance < window.SETTINGS.coords.winHeight/2){

				window.vent.trigger('scrollTo', {scrollTop: $closestHero.offset().top});

				this._killPageChangeDelay();
				this.pageChangeDelay = window.setTimeout(() => {
					window.vent.trigger('changeRoute', {route: '/' + this.pageId + '/' + $navItem.attr('data-anchor-id')});
				}, 750);
			}
			else {
				window.vent.trigger('changeRoute', {route: '/' + this.pageId + '/' + $navItem.attr('data-anchor-id')});
			}
		}
		else {

			let $selectedHero = $heroes.siblings(`[data-content-id="${$navItem.attr('data-anchor-id')}"]`);
			let pageSections = window.SETTINGS.pageSections[this.pageId];
			let heroOffset = $selectedHero.offset();

			this.isInteractionLocked = true;
			window.vent.trigger('changeRoute', {route: '/' + this.pageId + '/' + $navItem.attr('data-anchor-id')});
			window.vent.trigger('scrollTo', {scrollTop: heroOffset.top});
		}

		this._close();
	}

	_killPageChangeDelay(){
		if(this.pageChangeDelay){
			window.clearTimeout(this.pageChangeDelay);
			this.pageChangeDelay = null;
		}
	}

	// show / hide nav labels

	_showLabels(){

		if(!this.isLabelVisible || this.isLabelTransOut){

			let $navItems = this.$el.find('.nav-item');
			let routeObj = window.SETTINGS.router.getRouteObj();
			let pageSections = window.SETTINGS.pageSections[this.pageId];
			let sectionId = routeObj.sectionId || (pageSections.sections ? pageSections.sections[0].id : '');

			this._setActiveNavItem();

			if(this.labelDelay){
				window.clearTimeout(this.labelDelay);
				this.labelDelay = null;
			}

			if(this.isLabelTransOut){

				$navItems.each((index, value) => {

					let $navItem = $(value);
					let $title = $navItem.find('.title');
					let $dash = $navItem.find('.dash');

					TweenMax.killTweensOf([$navItem, $title, $dash]);
					TweenMax.to($dash, 0.3, {opacity:1, ease:'fade'});
					TweenMax.to($title, 0.3, {opacity:1, ease:'fade'});
				});
			}
			else {

				let stagger = 0.06;
				let initialDelay = 0.12;

				$navItems.each((index, value) => {

					let $navItem = $(value);
					let $title = $navItem.find('.title');
					let $dash = $navItem.find('.dash');

					TweenMax.killTweensOf([$navItem, $title, $dash]);
					TweenMax.fromTo($dash, 0.3, {scaleX:0, opacity:0, transformOrigin:'100% 50%'}, {scaleX:1, opacity:1, delay:stagger * index + initialDelay, ease:'fade'});
					TweenMax.fromTo($title, 0.3, {opacity:0, x:5}, {opacity:1, x:0, delay:stagger * index + 0.04 + initialDelay, ease:'fade'});
				});
			}

			this.$el.addClass('is-buttons-visible');

			this.isLabelVisible = true;
			this.isLabelTransOut = false;
		}
	}

	_hideLabels(delay){

		if(typeof(delay) === 'undefined'){ delay = 0; }

		if(!this.labelDelay || this.labelDelayTime >= delay){

			if(this.isLabelVisible){

				if(this.labelDelay){ window.clearTimeout(this.labelDelay); }

				this.labelDelayTime = delay;
				this.isLabelTransOut = true;

				this.labelDelay = window.setTimeout(() => {

					this.isLabelVisible = false;
					this.isLabelTransOut = false;

					let $navItems = this.$el.find('.nav-item');

					$navItems.each((index, value) => {

						let $navItem = $(value);
						let $title = $navItem.find('.title');
						let $dash = $navItem.find('.dash');

						TweenMax.killTweensOf([$navItem, $title, $dash]);
						TweenMax.to($dash, 0.3, {opacity:0, ease:'fade'});
						TweenMax.to($title, 0.3, {opacity:0, ease:'fade'});
					});

					this.labelDelay = null;
					this._updateHitArea();

					this.$el.removeClass('is-buttons-visible');

				}, delay * 1000);
			}
		}
	}

	// rebuild

	_rebuild(){

		if(!this.isTrans){

			this.isPendingRebuild = false;

			this._rebuildOut().then(() => {
				this._rebuildTemplate();
				this._addTemplateListeners();
				this._rebuildIn();
			});

		}
		else {
			this.isPendingRebuild = true;
		}
	}

	_checkPendingRebuild(){
		if(this.isPendingRebuild && !this.isTrans){
			this._rebuild();
		}
	}

	_updateCachedElements(){

		this.$primaryContentInnerBlocks = $('.primary-content:not(.old) .primary-content-inner');
		this.$progressIndicators = this.$navContent.find('.vert-progress');
		this.$progressHandles = this.$navContent.find('.vert-progress .progress-indicator');
		this.$progressLines = this.$navContent.find('.vert-progress .vert-line');
		this.$navItems = this.$el.find('.nav-item');
		this.$hitArea = this.$el.find('.hit-area');
		this.$heroes = $('.hero');

		this.isTouch = $('html').hasClass('supports-touchevents');
	}

	_updateHitArea(){

		let bounds = window.utils.PositioningUtils.getScrollOffset(this.$navContent);
		let maxWidth = 60; // initial hit area

		if(this.isHover || this.isLabelVisible){

			// expanded hit area

			this.$el.find('.nav-item a').each((index, value) => {

				let $navItem = $(value);
				let navItemWidth = $navItem.outerWidth();

				if(navItemWidth > maxWidth){
					maxWidth = navItemWidth;
				}
			});
		}

		this.hitAreaBounds = {
			top: bounds.top,
			bottom: bounds.bottom,
			left: bounds.right - maxWidth,
			right: bounds.right,
			width: maxWidth,
			height: bounds.height
		}

		this._checkMousePos();
	}

	_checkMousePos(){

		if(this.hitAreaBounds && this.mouseCoords && !this.isMobile){
			if(this.mouseCoords.clientX >= this.hitAreaBounds.left &&
				this.mouseCoords.clientX <= this.hitAreaBounds.right &&
				this.mouseCoords.clientY >= this.hitAreaBounds.top &&
				this.mouseCoords.clientY <= this.hitAreaBounds.bottom){

				if(!this.isHover){
					this._hitAreaOver();
					this.isInteractionLocked = false;
					// console.log('interaction locked false');
				}
			}
			else {
				if(this.isHover && !this.isInteractionLocked){
					this._hitAreaOut();
				}
			}
		}
	}

	_hitAreaOver(force){

		force = typeof(force) === 'undefined' ? false : (force === true);

		if((!this.isHover || force) && $('body').hasClass('page-loaded')){
			this.isHover = true;
			this.$el.addClass('is-hover');
			this._showLabels();
			this._updateHitArea();
			$('body').on('click', $.proxy(this._onOut, this));
		}
	}

	_hitAreaOut(delay, force){

		delay = typeof(delay) === 'undefined' ? 0.2 : delay;
		force = typeof(force) === 'undefined' ? false : (force === true);

		if(this.isHover || force){
			this.isHover = false;
			this.$el.removeClass('is-hover');
			this._hideLabels(delay);
			this._updateHitArea();
			$('body').off('click', $.proxy(this._onOut, this));
		}
	}

	_onOut(e){
		this._checkMousePos();
	}

	_setActiveNavItem(){

		if(this.pageId){

			let $closestHero;
			let heroIndex = 0;
			let routeObj = window.SETTINGS.router.getRouteObj();
			let pageSections = window.SETTINGS.pageSections[this.pageId];
			let sectionId = routeObj.sectionId || (pageSections.sections ? pageSections.sections[0].id : '');
			let heroLeeway = 20;

			if(this.$heroes && this.$navItems){

				if(this.isPartitionedPage){
				}
				else {

					for(let i=0; i<this.$heroes.length; i++){
						if(this.scrollTop >= this.$heroes.eq(i).offset().top - heroLeeway){
							heroIndex = i;
							$closestHero = this.$heroes.eq(i);
							sectionId = $closestHero.attr('data-content-id');
						}
						else {
							break;
						}
					}
				}

				if(this.sectionId !== sectionId || !this.$selectedNavItem || !this.$selectedNavItem.length || this.$selectedNavItem.attr('data-anchor-id') !== sectionId){

					this.$selectedNavItem = this.$navItems.siblings(`[data-anchor-id="${sectionId}"]`);

					this.$navItems.removeClass('is-active');
					this.$selectedNavItem.closest('.nav-item').addClass('is-active');
					this.sectionId = sectionId;

					if(!this.isPageChanging){

						let newRoute = '/' + this.pageId + '/';
						if(this.sectionId){ newRoute += this.sectionId + '/'; }

						window.vent.trigger('silentRoute', {route: newRoute});
					}
				}
			}
		}
	}

	_close(){
		this._hitAreaOut(0, true);
	}

	_rebuildTemplate(){

		let navItems = [];
		let pageSections = window.SETTINGS.pageSections[this.pageId];

		if(pageSections.sections){

			for(let i=0; i<pageSections.sections.length; i++){
				navItems.push({
					title: pageSections.sections[i].title,
					anchorId: pageSections.sections[i].id
				});
			}
		}

		this.$navContent.html(this.navTemplate({
			navItems: navItems
		}));

		this._updateCachedElements();
		this._updateHitArea();
	}

	_rebuildOut(){

		return new Promise((resolve, reject) => {

			// status method

			let checkStatus = () => {
				this.isTrans = false;
				this.$navContent.empty();
				this._checkPendingRebuild();
				resolve();
			}

			//

			if(!this.isTrans){

				this.isTrans = true;
				this.isTransOut = true;

				if(this.isTransOut || !this.isSectionShowing){ checkStatus(); }
				else {

					TweenMax.to(this.$navContent, 0.3, {opacity:0, ease:'fade', onComplete:() => {
						checkStatus();
					}});
				}
			}
		});
	}

	_rebuildIn(){

		return new Promise((resolve, reject) => {

			// status method

			let checkStatus = () => {
				this.isTrans = false;
				this._checkPendingRebuild();
				resolve();
			}

			//

			if(!this.isTrans){

				this.isTrans = true;
				this.isTransOut = false;

				TweenMax.fromTo(this.$navContent, 0.6, {opacity:0}, {opacity:1, ease:'fade', onComplete:() => {
					this._forceSectionShow();
					checkStatus();
				}});
			}
		});
	}

	// show / hide between sections

	_sectionShow(){

		this.isSectionShowing = true;

		this._onScroll();
		this._checkScrollVisibility();
	}

	_forceSectionShow(){

		this._sectionShow();

		if(window.SETTINGS.breakpoint.minWidth(1270)){
			this.isInteractionLocked = true;
			this._hitAreaOver(true);
		}
	}

	_sectionHide(){

		this.isSectionShowing = false;

		this._onScroll();
		this._checkScrollVisibility();
	}

	// show / hide

	_show(){
		this._sectionShow();
	}

	_hide(){
		this._sectionHide();
	}

	_checkScrollVisibility(){

		// console.log('_checkScrollVisibility', this.isSectionShowing, this.isScrollVisible, !this.isBadPage);

		if(this.isSectionShowing && !this.isBadPage){
			this.$el.addClass('is-showing');
		}
		else {
			this.$el.removeClass('is-showing');
			this._hitAreaOut(0, true);
		}
	}

	_updateHeroes(){

		let $heroes = $('.hero:not(.is-hidden)');
		let topOffset;

		// find top hero

		$heroes.each((index, value) => {

			let $hero = $(value);
			let offset = $hero.offset();

			if(isNaN(topOffset) || (offset.top < topOffset && offset.top >= 0)){
				topOffset = offset.top;
				this.$topHero = $hero;
			}
		});

		this.topHeroBounds = window.utils.PositioningUtils.getScrollOffset(this.$topHero);

		// bottom hero

		let $footerHeroes = $('.hero.footer-hero');
		let bottomOffset;

		$footerHeroes.each((index, value) => {

			let $hero = $(value);
			let offset = $hero.offset();

			if(isNaN(bottomOffset) || (offset.top > bottomOffset && offset.top >= 0)){
				bottomOffset = offset.top;
				this.$footerHero = $hero;
			}
		});

		if(this.$footerHero && this.$footerHero.length){
			this.footerHeroBounds = window.utils.PositioningUtils.getScrollOffset(this.$footerHero);
		}
		else {
			this.footerHeroBounds = {
				top: window.SETTINGS.coords.getDocHeight() - window.SETTINGS.coords.winHeight,
				left: 0,
				right: window.SETTINGS.coords.docWidth,
				bottom: window.SETTINGS.coords.getDocHeight(),
				width: window.SETTINGS.coords.docWidth,
				height: window.SETTINGS.coords.winHeight
			}
		}

	}

	//

	_getClosestHero(){

		let $heroes = $('.hero');
		let $closestHero;
		let closestDistance = -1;

		$heroes.each((index, value) => {

			let $hero = $(value);
			let heroOffset = window.utils.PositioningUtils.getExtendedOffset($hero);

			let topDist = Math.abs(this.scrollTop + window.SETTINGS.coords.winHeight/2 - heroOffset.top);
			let bottomDist = Math.abs(this.scrollTop + window.SETTINGS.coords.winHeight/2 - heroOffset.bottom);

			if(closestDistance < 0 || topDist < closestDistance){
				$closestHero = $hero;
				closestDistance = topDist;
			}
			else if(bottomDist < closestDistance){
				$closestHero = $hero;
				closestDistance = topDist;
			}
		});

		return $closestHero;
	}

	//

	_enable(){ }
	_disable(){ }

	_domUpdate(){
		this._updateHeroes();
	}

	_resize(){

		let docWidth = window.SETTINGS.coords.docWidth;
		let containerWidth = window.SETTINGS.coords.containerWidth;

		if(window.SETTINGS.breakpoint.maxWidth('screen-medium')){ // && this.isTouch){
			this.isMobile = true;
		}
		else {
			this.isMobile = false;
		}

		// console.log(docWidth, containerWidth);

		if(docWidth > containerWidth){
			TweenMax.set(this.$el, {x: 0 - Math.round((docWidth - containerWidth)/2)});
		}
		else {
			TweenMax.set(this.$el, {clearProps: 'x'});
		}

		this._updateHeroes();
		this._updateHitArea();
		this._onScroll();
	}
}

module.exports = ScrollNav;
